import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6y3r9ztd39: FaireBrandEntity = {
  token: "b_6y3r9ztd39",
  type: "brand",
  name: "Freshly Picked",
  avatarUrl:
    "https://cdn.faire.com/fastly/394aa5a4d0a463ddceb851f2e036f81d9c9f50b9c540a81f253cff9fe8673bc6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/afa8e36b2f3b5385c906bd06a207e1f897906d72d15466f17bd3270a37acd585.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/394aa5a4d0a463ddceb851f2e036f81d9c9f50b9c540a81f253cff9fe8673bc6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/afa8e36b2f3b5385c906bd06a207e1f897906d72d15466f17bd3270a37acd585.jpeg",
  location: "Lehi, UT, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 8,
  isTopShop: true,
  isInsider: true,
  description:
    "Freshly Picked is a baby brand built to make life with little ones easier, more organized, and more beautiful. Since 2009, millions of moms have trusted us for the products they use every day. What began with a single pair of handmade baby shoes has grown into a full collection of premium essentials, including moccasins, diaper bags, swaddles, and more!\n\nWe believe motherhood deserves better than clunky, uninspired products. That’s why everything we make is thoughtfully designed to blend style and function, helping moms feel confident, prepared, and proud in every stage of motherhood.\n\nAt Freshly Picked, we know the little things mean everything — from the first steps to the long nights and every milestone along the way! Our products are made to carry moms through it all, so she can focus on what truly matters: the moments with her baby.\n\nWe aren’t just another baby brand — we’re Freshly Picked.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:25.829Z",
    importedBy: "entity-db-cli",
  },
};
